import { render, staticRenderFns } from "./ArchiveReplacement.vue?vue&type=template&id=b83c22dc&"
import script from "./ArchiveReplacement.vue?vue&type=script&lang=js&"
export * from "./ArchiveReplacement.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveReplacement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveReplacement.vue"
export default component.exports